import { Injectable } from '@angular/core';
import { WmHttpService } from '../../../../services/http/wm-http.service';
import { environment } from "@wms/app";
import { initCaps } from '@wm/core';

@Injectable({
  providedIn: 'root'
})
export class JavaService {
  TARGET = 'JavaService'
  API_META = {
    create: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/javaservice/:serviceId",
      method: "POST"
    },
    open: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/javaservice/:serviceId",
      method: "GET"
    },
    save: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/javaservice/:serviceId",
      method: "PUT"
    },
    remove: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/services/:serviceId",
      method: "DELETE"
    },
    metadata: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/javaservice/:serviceId/metadata",
      method: "GET"
    }
  }

  constructor(private wmHttpService: WmHttpService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  create(params: any) {
    return this.wmHttpService.execute({
      target: "JavaService",
      action: "create",
      data: params.packageName + '.' + initCaps(params.serviceName),
      urlParams: {
        "projectId": params.projectId,
        "serviceId": params.serviceName
      },
      spinnerInfo: {
        showSpinner: false
      }
    })
  }

  open(params: any) {
    return this.wmHttpService.execute({
      target: "JavaService",
      action: "open",
      urlParams: {
        "projectId": params.projectId,
        "serviceId": params.serviceName
      }
    })
  }

  save(params: any) {
    return this.wmHttpService.execute({
      target: "JavaService",
      action: "save",
      data: params.content,
      urlParams: {
        "projectId": params.projectId,
        "serviceId": params.serviceName
      }
    })
  }

  remove(params: any) {
    return this.wmHttpService.execute({
      target: 'JavaService',
      action: 'remove',
      urlParams: {
        "projectId": params.projectId,
        "serviceId": params.serviceName
      }
    })
  }

  getMetadata(params: any) {
    return this.wmHttpService.execute({
      target: "JavaService",
      action: "metadata",
      urlParams: {
        "projectId": params.projectId,
        "serviceId": params.serviceName
      },
      spinnerInfo: {
        showSpinner: false
      }
    })
  }
}
